var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMoveItem2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 47,
    viewBox: "0 0 48 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1645_4294",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 48,
    height: 47
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 47,
    height: 47,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1645_4294)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40.395 24.9691H17.2979V22.0316H40.395L36.8323 18.4689L38.8959 16.3451L46.0512 23.5003L38.8959 30.6556L36.8323 28.5318L40.395 24.9691ZM30.2719 17.3614V10.3947C30.2719 10.2187 30.2154 10.0743 30.1025 9.96139C29.9892 9.84846 29.8448 9.79199 29.6692 9.79199H10.8956C10.7197 9.79199 10.5753 9.84846 10.4624 9.96139C10.3494 10.0743 10.293 10.2187 10.293 10.3947V36.606C10.293 36.7819 10.3494 36.9263 10.4624 37.0393C10.5753 37.1522 10.7197 37.2087 10.8956 37.2087H29.6692C29.8448 37.2087 29.9892 37.1522 30.1025 37.0393C30.2154 36.9263 30.2719 36.7819 30.2719 36.606V29.6392H33.2094V36.606C33.2094 37.5825 32.8634 38.4168 32.1715 39.1087C31.4799 39.8004 30.6458 40.1462 29.6692 40.1462H10.8956C9.91909 40.1462 9.08484 39.8004 8.3929 39.1087C7.70128 38.4168 7.35547 37.5825 7.35547 36.606V10.3947C7.35547 9.41811 7.70128 8.58386 8.3929 7.89192C9.08484 7.2003 9.91909 6.85449 10.8956 6.85449H29.6692C30.6458 6.85449 31.4799 7.2003 32.1715 7.89192C32.8634 8.58386 33.2094 9.41811 33.2094 10.3947V17.3614H30.2719Z",
    fill: "#348BDC"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoveItem2);
export default __webpack_public_path__ + "static/media/move_item (2).a6bb5d97a67b0c30bc6bf1077adbdb06.svg";
export { ForwardRef as ReactComponent };